/* Two classes: .alert-hot loads after this module and would set 12px side padding; the banner kept 14px. */
:global(.alert-hot).banner { display: flex; align-items: center; justify-content: space-between; gap: 16px; width: 100%; padding: 10px 14px; }
.dismiss { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--hot); white-space: nowrap; }
/* 44px hit area that bleeds into the banner padding, so the banner keeps its height. */
@media (max-width: 639px) {
  .dismiss { display: inline-flex; align-items: center; min-height: 44px; margin: -10px -14px -10px 0; padding: 0 14px; }
}
